import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import PrescriptionsList from './InlinePrescriptionsList/InlinePrescriptionsList.js';
import PrescriptionDownloadsList from './PrescriptionDownloadsList/PrescriptionDownloadsList.js';
import { NoPrescription } from '../components/NoPrescription/NoPrescription.js';

const PrescriptionsListContainer = ()=>{
    const { featureConfigs  } = useFeatureToggles();
    const { prescriptionList  } = featureConfigs;
    if (prescriptionList === null || prescriptionList === void 0 ? void 0 : prescriptionList.includes('CCC')) {
        // Vision Express uses a custom API to fetch their prescriptions
        return /*#__PURE__*/ React.createElement(PrescriptionsList, null);
    }
    if (prescriptionList === null || prescriptionList === void 0 ? void 0 : prescriptionList.includes('DOWNLOADABLE')) {
        return /*#__PURE__*/ React.createElement(PrescriptionDownloadsList, null);
    }
    return /*#__PURE__*/ React.createElement(NoPrescription, null);
};
var PrescriptionsListContainer$1 = PrescriptionsListContainer;

export { PrescriptionsListContainer$1 as default };
//# sourceMappingURL=PrescriptionsListContainer.js.map
